<!-- src/apps/workspace/account/settings/ApiSettings.vue -->

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import AccountCard from '@/apps/workspace/components/account/AccountCard.vue';
  import APIKeyForm from '@/apps/workspace/components/account/APIKeyForm.vue';
  import OIcon from '@/shared/components/icons/OIcon.vue';
  import SettingsLayout from '@/apps/workspace/layouts/SettingsLayout.vue';
  import { useAccountStore } from '@/shared/stores/accountStore';
  import { useBootstrapStore } from '@/shared/stores/bootstrapStore';
  import { storeToRefs } from 'pinia';
  import { onMounted } from 'vue';

  const { t } = useI18n();
  const accountStore = useAccountStore();
  const { account } = storeToRefs(accountStore);
  const bootstrapStore = useBootstrapStore();
  const apiConfig = bootstrapStore.apiConfig;

  onMounted(async () => {
    await accountStore.fetch();
  });
</script>

<template>
  <SettingsLayout>
    <AccountCard v-if="!apiConfig.enabled">
      <div class="px-6 py-10 text-center">
        <OIcon
          collection="heroicons"
          name="x-circle-solid"
          class="mx-auto mb-3 size-8 text-day-line-2 dark:text-white/20"
          aria-hidden="true" />
        <p class="text-[13px] text-day-ink-faint dark:text-night-ink-faint">
          {{ t('web.settings.api.api_disabled_notice') }}
        </p>
      </div>
    </AccountCard>

    <div
      v-else
      class="space-y-5">
      <!-- API Key Section -->
      <AccountCard
        :icon="{ collection: 'heroicons', name: 'key' }"
        :title="t('web.account.api_key')"
        :subtitle="t('web.settings.api.manage_api_keys')">
        <div class="p-[22px]">
          <APIKeyForm :apitoken="account?.apitoken ?? undefined" />
        </div>
      </AccountCard>

      <!--
        Warning notice, mock: a butter-yellow slab OUTSIDE the card (it is a
        caveat about the card, not part of it), square corners like everything
        else on this surface.
      -->
      <div
        class="flex gap-3 border border-amber-300 bg-amber-50 px-[18px] py-4
          dark:border-amber-500/30 dark:bg-amber-950/25">
        <OIcon
          collection="heroicons"
          name="exclamation-triangle"
          class="mt-px size-[18px] shrink-0 text-amber-600 dark:text-amber-400"
          aria-hidden="true" />
        <div>
          <p class="text-sm font-semibold text-amber-800 dark:text-amber-300">
            {{ t('web.settings.api.important_notice') }}
          </p>
          <p class="mt-1 text-[13px] leading-relaxed text-amber-700 dark:text-amber-400/90">
            {{ t('web.settings.api.regenerating_key_warning') }}
          </p>
        </div>
      </div>
    </div>
  </SettingsLayout>
</template>
